import React from "react";
import Heading from "./Heading";
import { LiaChessBishopSolid } from "react-icons/lia";
import { IoIosStarOutline } from "react-icons/io";
import { IoClipboardOutline, IoSearchOutline } from "react-icons/io5";
import { HiOutlineUserGroup } from "react-icons/hi";
import { PiUserCircleGearLight } from "react-icons/pi";
import { Helmet } from "react-helmet";
import homebackground from './../image/design.mp4';
import { motion } from 'framer-motion';

const Business = ({ title }) => {
  const isBusinessSolution = title === "Business Solution";

  return (
    <>
    <div className="relative w-full max-w-[1400px] mx-auto mt-20 px-4 overflow-hidden z-0 rounded-xl pb-10">
      
      {/* Video Background */}
      <motion.video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover  lg:block z-0 rounded-lg "
        initial={{ scale: 1 }}
        animate={{ scale: [1, 1.05, 1] }}
        transition={{ duration: 8, ease: 'easeInOut', repeat: Infinity, repeatType: 'reverse' }}
      >
        <source src={homebackground} type="video/mp4" />
      </motion.video>

      {/* Content Section */}
      <div className="relative z-10 lg:w-[70%] w-full ml-auto bg-opacity-90 p-10 ">
        <Helmet>
          <title>Nexify InfoSystems</title>
          <meta name="description" content="Harness our capabilities in strategy, design, development, and integration to address critical business needs." />
          <meta name="keywords" content="Business solutions, strategy, development, integration, revenue, cost optimization, product development, customer experience, employee experience" />
        </Helmet>
        <h1 className="text-[#e3e4eb] text-[35px] md:text-[40px] lg:text-[48px] font-[700] leading-[54px] mt-20">Leverage our expertise to solve your business challenges.        </h1>
      
                 <div className="md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-8 mt-10 flex flex-row overflow-x-auto md:overflow-x-hidden">
          {[ 
            {
              title: "Accelerate Revenue",
              subtitle: "UNLEASH NEW REVENUE STREAMS",
              text: "Partner with Nexify to discover new revenue streams or enhance your existing ones, giving your business a competitive advantage."
            },
            {
              title: "Optimize Costs",
              subtitle: "CUT COSTS, NOT QUALITY",
              text: "We create tailored solutions that automate essential processes, helping you save money, time, and effort."
            },
            {
              title: "Expedite Product Development",
              subtitle: "FASTER ROI FOR YOUR PRODUCTS",
              text: "Nexify has the expertise and tools to manage complex projects, helping you reduce costs and speed up time to market."
            },
            {
              title: "Improve Employee Experience",
              subtitle: "DRIVE MORE PRODUCTIVITY",
              text: "Nexify can enhance collaboration, decision-making, and workflows to ensure your business—and your employees—thrive."
            },
            {
              title: "Enhance Customer Experience",
              subtitle: "AMPLIFY YOUR BRAND",
              text: "Nexify can help your business anticipate customer needs and broaden your reach to engage more customers than ever."
            },
            {
              title: "Speed To Market",
              subtitle: "DELIVER RESULTS FAST",
              text: "Our cost-effective solutions accelerate the development process, delivering results in a fraction of the time."
            }
          ].map((item, index) => (
<motion.div
  key={index}
  className="flex flex-col items-start border border-[#8d8d91] rounded-lg m-[10px] lg:max-w-[290px] max-w-[200px] p-[25px] transition-all duration-500 ease-in-out cursor-pointer flex-shrink-0"
  style={{
    background: "hsla(0, 2%, 44%, 0.64)", // Semi-transparent background
    display: "flex",
    flexDirection: "column",
  }}
  whileHover={{
    scale: 1.05,
    rotate: 3,
  }}
  whileTap={{ scale: 0.95 }}
  transition={{ duration: 0.3, ease: "easeInOut" }}
>
  {/* Fixed height for h2 */}
  <h2 className="font-[700] text-[#f6993e] text-[21px] mb-2 h-[60px] flex items-center w-full">
  {item.title}
</h2>
<div className="w-full border-b-2 lg:mt-0 mt-5 border-[#8d8d91]"></div>

  {/* Subtitle with minimum height */}
  <p className="text-[15px] text-white text-bold mb-2 mt-2 min-h-[25px] flex items-center">
    {item.subtitle}
  </p>

  {/* Description with min-height to keep uniformity */}
  <p className="text-[14px] hover:text-[#fafafa] font-[300] leading-[24px] text-[#fafafa] flex-grow min-h-[50px]">
    {item.text}
  </p>
</motion.div>

          ))}
        </div>
      </div>
    </div>
    <div className="mt-10 w-full max-w-[1400px] mx-auto border-b-2 border-[#cacbd1]"></div>
    </>
  );
};

export default Business;
